import * as React from 'react';
import classNames from 'classnames';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import styles from './LabelWithDescription.module.scss';
import {ToolTipItem} from "@Components/ToolTip/ToolTipItem";

type LabelWithDescriptionProps = {
    text?: string;
    description?: string | React.ReactElement;
    label?: string | React.ReactElement;
    className?: string;
    required?: boolean;
    innerClassName?: string;
};

export const LabelWithDescription: React.FC<LabelWithDescriptionProps> = React.memo(({ text, label, description, required, className, innerClassName }) => {
    const [isTooltipOpen, setIsTooltipOpen] = React.useState(false);

    const labelRef = React.useRef(null);

    const handleMouseEnter = () => {
        setIsTooltipOpen(true);
    }

    const handleMouseLeave = () => {
        setIsTooltipOpen(false);
    }

    return (
        <div className={classNames(styles.wrap, className)}>
            <div className={styles.text}>
                <div>{text}{required ? <span className={styles.required}>*</span> : ''}</div>

                {description && (
                    <div
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    >
                        <div
                            ref={labelRef}
                            className={styles.label}
                        >
                            {label || <AiOutlineInfoCircle />}
                        </div>

                        <ToolTipItem
                            target={labelRef}
                            isOpen={isTooltipOpen}
                            autohide={false}
                            className={classNames(styles.tooltip, innerClassName)}
                        >
                            {description}
                        </ToolTipItem>
                    </div>
                )}
            </div>
        </div>
    );
});
